import { HttpClient } from "@angular/common/http";
import { IAPIItemResult, IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import EntityFieldsCatalogAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/fields-catalog/field-catalog.entity";
import { EntityEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/entity.enum";
import { ActionEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/action-entity.enum";
import { UpdateFieldPayload } from "./interfaces/field-catalog.interface";
import { andWhere, buildQuery, Ops, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import UserFieldCatalogAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/fields-catalog/user-field-catalog/user-field-catalog.entity";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";

const apiUrl = env.API_AVE_FIELD_CATALOG;
const moduleName = "entity-fields-catalog";
const moduleNameMaster = "user-field-catalog";

@Injectable({
  providedIn: "root",
})
export class CompanyFieldCatalogService extends AbstractService<
  EntityFieldsCatalogAttributes,
  EntityFieldsCatalogAttributes,
  EntityFieldsCatalogAttributes
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  getFields(companyId: string, entity: EntityEnum, action: ActionEnum): Observable<IAPIItemResult<EntityFieldsCatalogAttributes>> {
    //No cuenta con filter, se agrego el query respectivo por si se tiene a futuro
    const query = buildQuery<EntityFieldsCatalogAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("isActive", Ops.eq(true))
    );
    
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}/${entity}?action=${action}`;
    return this.http.get<IAPIItemResult<EntityFieldsCatalogAttributes>>(API_URL);
  }

  updateField(id: string, fieldId: string, payload: UpdateFieldPayload) {
    const API_URL: string = `${apiUrl}api/${moduleName}/${id}/fields?fieldId=${fieldId}`;
    return this.http.patch(API_URL, payload);
  }

  getFieldsMaster(companyId: string, entityType: UserFieldEntityTypeEnum): Observable<IAPIItemResult<UserFieldCatalogAttributes>> {
    const query = buildQuery<UserFieldCatalogAttributes>(
      where('_deleted', Ops.eq(false))
    );
    
    const API_URL: string = `${apiUrl}api/${moduleNameMaster}/${companyId}/${entityType}`;
    return this.http.get<IAPIItemResult<UserFieldCatalogAttributes>>(API_URL);
  }

  saveFieldsMaster(payload: UpdateFieldPayload, method: 'POST' | 'PATCH', id?: string): Observable<any> {
    if(method === 'POST') {
      const API_URL: string = `${apiUrl}api/${moduleNameMaster}`;
      return this.http.post(API_URL, payload);
    }else if(method === 'PATCH') {
      const API_URL: string = `${apiUrl}api/${moduleNameMaster}/${id}`;
      return this.http.patch(API_URL, payload);
    }
    throw new Error('Invalid method for saveFieldsMaster');
  }

}